export default __webpack_public_path__ + "static/media/1718 knife block B side.17c36415.png";